class CombinedInternationalPicker extends HTMLElement {
  constructor() {
    super();

    // Initialize internal state variables
    this.baseHandle = this.dataset.baseHandle;
    this.size = this.dataset.size;
    this.sectionId = this.dataset.sectionId;

    // Grab references to DOM elements
    this.leftSelect = this.querySelector('[data-wing="left"]');
    this.rightSelect = this.querySelector('[data-wing="right"]');

    // Initialize wing values
    this.leftWingValue = this.leftSelect?.value;
    this.rightWingValue = this.rightSelect?.value;

    console.log('CIP', 'constructor', this);
  }

  connectedCallback() {
    console.log('CIP', 'connectedCallback');

    // Bind listeners when the element is added to the document
    if (this.leftSelect) {
      this.leftSelect.addEventListener('change', this.onLeftWingChange.bind(this));
    }
    if (this.rightSelect) {
      this.rightSelect.addEventListener('change', this.onRightWingChange.bind(this));
    }

    // Shopify-specific pub/sub for size changes
    this.onVariantChangeUnsubscriber = subscribe(
      PUB_SUB_EVENTS.optionValueSelectionChange,
      this.handleOptionValueChange.bind(this),
    );
  }

  disconnectedCallback() {
    // Clean up listeners if the element is removed
    if (this.leftSelect) {
      this.leftSelect.removeEventListener('change', this.onLeftWingChange);
    }
    if (this.rightSelect) {
      this.rightSelect.removeEventListener('change', this.onRightWingChange);
    }
    if (this.onVariantChangeUnsubscriber) {
      this.onVariantChangeUnsubscriber();
    }
  }

  handleOptionValueChange(event) {
    const size = event?.data?.target?.defaultValue;
    console.log('CIP', 'handleOptionValueChange', { event, size });
    this.size = this.normalizeSizeLabel(size);
    this.dataset.size = size;
  }

  onLeftWingChange(event) {
    this.leftWingValue = event.target.value;
    this.updateProduct();
  }

  onRightWingChange(event) {
    this.rightWingValue = event.target.value;
    this.updateProduct();
  }

  updateProduct() {
    // Construct the handle based on your specific requirements:
    // Left Wing + Right Wing (e.g., "ca-00" or "us-ca")
    const targetHandle =
      `${this.baseHandle}${this.leftWingValue}-${this.rightWingValue}`.toLocaleLowerCase();

    console.log('CIP', 'updateProduct', { targetHandle });
    this.renderSelectedProduct(targetHandle);
  }

  async renderSelectedProduct(handle) {
    console.log('[CIP] renderSelectedProduct() called');
    console.log('[CIP] Target handle:', handle);

    const sectionId = this.sectionId;
    let url = `/products/${handle}?section_id=${sectionId}`;
    let siblingVariantId = null;

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('variant')) {
      const mappingUrl = `/products/${handle}?section_id=variant-size-mapping`;

      const mappingResponse = await fetch(mappingUrl);
      if (!mappingResponse.ok) {
        throw new Error('Failed to fetch variant mapping');
      }

      const mappingHtml = await mappingResponse.text();
      const mappingDoc = new DOMParser().parseFromString(mappingHtml, 'text/html');

      const jsonScript = mappingDoc.querySelector('#variant-size-mapping');
      if (!jsonScript) {
        throw new Error('Variant mapping JSON not found');
      }

      const mappingData = JSON.parse(jsonScript.textContent);
      const match = mappingData.variants.find(
        (v) => this.normalizeSizeLabel(v.size) === this.normalizeSizeLabel(this.size),
      );
      if (!match) {
        console.warn('[CIP] No matching variant for size, falling back to default');
      } else {
        siblingVariantId = match ? match.id : null;
        url = `/products/${handle}?section_id=${sectionId}&variant=${siblingVariantId}`;
      }
    }

    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const htmlText = await response.text();
      const parsedDoc = new DOMParser().parseFromString(htmlText, 'text/html');
      const newSection = parsedDoc.getElementById(`shopify-section-${sectionId}`);
      const currentSection = document.getElementById(`shopify-section-${sectionId}`);

      if (!newSection || !currentSection) {
        console.error('[CIP] Section not found in one of the DOMs');
        console.log('[CIP] newSection:', newSection);
        console.log('[CIP] currentSection:', currentSection);
        throw new Error(`Section ${sectionId} missing`);
      }

      if (!newSection.querySelector('combined-international-picker')) {
        throw new Error(`Section ${sectionId} missing`);
      }

      currentSection.outerHTML = newSection.outerHTML;
      if (siblingVariantId) {
        window.history.replaceState({}, '', `/products/${handle}?variant=${siblingVariantId}`);
      } else {
        window.history.replaceState({}, '', `/products/${handle}`);
      }

      publish(PUB_SUB_EVENTS.productVariantChange, {
        data: { sectionId, html: newSection.outerHTML },
      });

      console.log('[CIP] Section replacement complete ✅');
    } catch (error) {
      console.error('[CIP] Error updating product customization:', error);
    }
  }

  normalizeSizeLabel(value) {
    if (!value) return '';

    const normalized = value.toString().trim().toLowerCase();
    const aliases = {
      'xxx-small': 'xxxs',
      'xx-small': 'xxs',
      'x-small': 'xs',
      small: 's',
      medium: 'm',
      large: 'l',
      'x-large': 'xl',
      'xx-large': 'xxl',
      'xxx-large': 'xxxl',
      'xxxx-large': 'xxxxl',
    };

    return aliases[normalized] || normalized;
  }
}

customElements.define('combined-international-picker', CombinedInternationalPicker);
